module.exports = __webpack_public_path__ + "static/surfer-91dfef7946bb4ba15f2f5166eb6ac842.jpg";